import { NgClass } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { VersionService } from 'src/app/shared/services/version/version.service';


@Component({
  standalone: true,
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [RouterLink, NgClass]
})
export class FooterComponent {
    @Input() isLoggedIn: boolean = false;

    version = inject(VersionService);
    formattedVersion = this.version.formattedVersion;
    isSnapshot = this.version.isSnapshot;

}
